import { api } from "../../api/API";
import { Task } from "../../api/Tasks";
import { snackText, snackUndo, useSnackAction } from "../../misc/SnackAction";

// vibrate is a short tick, where the browser has it
export function vibrate() {
    if (typeof navigator !== "undefined" && navigator.vibrate) navigator.vibrate(10);
}

// useCompleteTask ticks a task off from a phone list or the task sheet, and offers
// "Undo" for a few seconds after. Undo also takes back the next task a repeat made,
// while nobody has changed it.
export function useCompleteTask() {
    const undo = useSnackAction(async (input: { id: number; onUndone?: () => void; onSaved?: (task: Task) => void }) => {
        const result = await api.tasks.complete({ id: input.id, completed: false, undo: true });
        if (input.onSaved) input.onSaved(result);
        if (input.onUndone) input.onUndone();

        return snackText(result.nextRepeatKept ? "Reopened. The next repeat was kept." : "Reopened");
    }, { success: "Reopened" });

    // onFail puts back whatever the caller showed ahead of the answer, onUndone shows
    // the task open again after an undo, and onSaved hands over the task after either
    return useSnackAction(async (input: {
        id: number;
        completed: boolean;
        onFail?: () => void;
        onUndone?: () => void;
        onSaved?: (task: Task) => void;
    }) => {
        try {
            const result = await api.tasks.complete({ id: input.id, completed: input.completed });
            if (input.onSaved) input.onSaved(result);
        } catch (e) {
            if (input.onFail) input.onFail();
            throw e;
        }

        if (input.completed) return snackUndo("Completed", () => undo.callback({
            id: input.id,
            onUndone: input.onUndone,
            onSaved: input.onSaved,
        }));
    }, { success: "Reopened" });
}
